export const mergeKeys = {
  all: () => ['merges'] as const,
  candidates: () => [...mergeKeys.all(), 'candidates'] as const,
  history: () => [...mergeKeys.all(), 'history'] as const,
  preview: (winnerId: string, loserId: string) =>
    [...mergeKeys.all(), 'preview', winnerId, loserId] as const,
}
